// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Configuration } from '@azure/msal-browser';

export const authObject = {
  clientId: '37bfe7c8-b671-46a7-8171-a0f10d602151',
  authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47/',
  redirectUri: 'https://delightful-dune-06c84ff1e.3.azurestaticapps.net'
};

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: authObject,
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
// This scope is to request the MS authToken with the permissions to make calls to Graph apis (inclusing calendar)
export const loginRequest = {
  scopes: ['User.Read']
};

// This scope is to request the MS authToken with the permissions to make calls to Function Apis hosted on Function App.
export const funcAppRequest = {
  scopes: ['api://459ec9a0-5c6a-480d-ae41-aa0c587f76f2/user_impersonation']
};

// This scope grants tokens that can be exchanged for ACS tokens for the Teams user.
export const teamsEndpointRequest = {
  scopes: []
};
